export default __webpack_public_path__ + "static/media/4.4fae8291.png";